var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_chevron_big_left",
    "data-name": "arrow / chevron_big_left",
    transform: "translate(14 8) rotate(-90)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.857140064239502 -0.7145113945007324 L 0.6999292373657227 -7 L 6.857140064239502 -13.28548908233643 L 7.300070285797119 -12.83333015441895 L 1.928529977798462 -7.349890232086182 L 1.585780024528503 -7 L 1.928529977798462 -6.650109767913818 L 7.300070285797119 -1.166669726371765 L 6.857140064239502 -0.7145113945007324 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.857140064239502 8.881784197001252e-16 L 0 -7 L 6.857140064239502 -14 L 8 -12.83333015441895 L 2.285710096359253 -7 L 8 -1.166669964790344 L 6.857140064239502 8.881784197001252e-16 Z",
    stroke: "none",
    fill: "#2e567a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlue);
export default __webpack_public_path__ + "static/media/arrowDownBlue.1ef643e01a83b471e3b5c24e7ab33c63.svg";
export { ForwardRef as ReactComponent };